import apiClient from '@disco/api/server'
import type { ClientLibraryId } from 'types/client-library'
import type {
  LicenseRequestSubmissionsPage,
  RequestFormVersion,
} from 'types/license-requests'

import { api } from './index'

export type {
  LicenseRequestSubmission,
  LicenseRequestSubmissionTrack,
} from 'types/license-requests'

export const PAGE_SIZE = 20

type QueryArg = {
  libraryId: ClientLibraryId
  ordering: string
  page: number
}

export const licenseRequestsApi = api
  .enhanceEndpoints({
    addTagTypes: ['LicenseRequestSubmissions', 'RequestFormVersion'],
  })
  .injectEndpoints({
    endpoints: build => ({
      getLicenseRequestSubmissions: build.query<
        LicenseRequestSubmissionsPage,
        QueryArg
      >({
        queryFn: async ({ libraryId, ordering, page }) => {
          try {
            const data = await apiClient.getLicenseRequestSubmissions({
              libraryId,
              ordering,
              offset: (page - 1) * PAGE_SIZE,
              pageSize: PAGE_SIZE,
            })
            return { data }
          } catch (error) {
            return { error: { status: 'FETCH_ERROR', error: String(error) } }
          }
        },
        providesTags: (_result, _error, { libraryId }) => [
          { type: 'LicenseRequestSubmissions', id: libraryId },
        ],
      }),
      getRequestFormVersion: build.query<RequestFormVersion, number>({
        queryFn: async formVersionId => {
          try {
            const data = await apiClient.getRequestFormVersion(formVersionId)
            return { data }
          } catch (error) {
            return { error: { status: 'FETCH_ERROR', error: String(error) } }
          }
        },
        providesTags: (_result, _error, formVersionId) => [
          { type: 'RequestFormVersion', id: formVersionId },
        ],
      }),
    }),
  })

export const {
  useGetLicenseRequestSubmissionsQuery,
  useGetRequestFormVersionQuery,
} = licenseRequestsApi
